<template>
  <div class="rewardItem" v-bind:style="{left:parseInt(stage*100*0.874/8)+'vw'}" @click="getReward">
    <div class="rewardItemImg">
      <img :src="img" />
    </div>
    <p>{{stage}}</p>
    <label v-if="mystatus===0">{{trans['cannot']}}</label>
    <label v-if="mystatus===1"><i class="goldtoyellow">{{trans['can']}} &nbsp;</i></label>
    <label v-if="mystatus===2"><i class="green">{{trans['has']}} &nbsp;</i></label>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mytimes: 0,
      mystatus: 0,
      myhas: 0
    }
  },
  props: {
    name: '',
    img: '',
    stage: 0,
    num: 0,
    pk: 0,
    trans: {},
    status: 0,
    has: 0,
    times: 0
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.myhas === 0 && this.times >= this.stage) {
        this.mystatus = 1
      }
      if (this.myhas === 1) {
        this.mystatus = 2
      }
    },
    getReward () {
      if (this.myhas === 0 && this.mytimes >= this.stage) {
        this.$emit('getReward', {pk: this.pk, stage: this.stage})
      }
    }

  },
  watch: {
    status: {
      immediate: true,
      handler (val) {
        this.mystatus = val
      }
    },
    has: {
      immediate: true,
      handler (val) {
        this.myhas = val
        if (this.myhas === 1) {
          this.mystatus = 2
        }
      }
    },
    times: {
      immediate: true,
      handler (val) {
        this.mytimes = val
        if (this.myhas === 0 && this.mytimes >= this.stage) {
          this.mystatus = 1
        }
        if (this.myhas === 1) {
          this.mystatus = 2
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/items/rewardItem.vue